// JavaScript source code
import { useRef, useState } from 'react';
import GameImageHeader from './GameImageHeader';
import './styles/PlayerInfoUpdatedMessage.css';

function PlayerInfoUpdated() {

    return (
        <div className="playerPage">
            <div className="titleLine">
                <GameImageHeader />
                <div className="topBody">
                    <div className="infoPlayer">
                        <h2 className="taglineTopPlayer">Support A New Favorite Game</h2>
                        <h2 className="taglineBottomPlayer">Just By Playing It</h2>
                        <p className="subTagLinePlayer">Try a bunch of new games for one price.<br/>Continue to support by playing your favorites.</p>
                    </div>
                </div>
            </div>
            <div className="playerInfoContainer">
                <h1 className="dareToHeader">DARE TO</h1>
                <h1 className="playerSectionHeader">Support New Games</h1>
                <div className="SupportDiv">
                    <div className="updatedTile">
                        <p className="UpdatedTileInfo">Indie games are one of the biggest sources of innovation across the whole games industry. However, making these innovative news games requires a huge amount of support but are seen as too risky for the typical publishers and investors. So, we want to connect players directly with these new games so that they provide support for the games they enjoy the most.</p>
                    </div>
                </div>
                <h1 className="dareToHeader">DARE TO</h1>
                <h1 className="playerSectionHeader">Support at No Risk</h1>
                <div className="paymentStep">
                    <p className="updatedRiskTileInfo">Unlike and early access launch or crowd funding project, you don't have to pay the entire price of the game upfront. Instead you are paying a much smaller monthly fee for a whole library of games. This allows you to try a game and, if it isn't to your taste, move to try another game without losing the money you spent on it. No refunds, emails, or customer support request needed!</p>
                </div>
                <h1 className="dareToHeader">DARE TO</h1>
                <h1 className="playerSectionHeader">Play Tailored Recommendations</h1>
                <div className="playStep">
                    <p className="updatedRecsTileInfo">Because we are focused on delivering the best content and experience for you without the influence of price points or platfrom fees, we can provide high quality game reccomendations that are targeted at your specific tastes and play habits. Since you are paying for the entire library rather than per game, you are able to try any and all of our reccomendations at no extra cost and no risk if it isn't to your taste.</p>
                </div>*/
            </div>
        </div>
    );
}

export default PlayerInfoUpdated;